import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import h5Share from '@/utils/h5Share'
import styled from "styled-components";
import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel';
import ShareModal from './components/share';
import styles from '@/styles'

import { handleUploadTrace } from '../activity_30/stock';
import { Toast } from "antd-mobile";
import ModalView from '@/components/modal-view'
import bgImage from './images/bg.png'
import bgModal from './images/bg1.png'
import bgModal2 from './images/bg2.png'
import CloseBtn from './images/close@2x.png'

import ExplainText from './images/rules.png'
import bridge from '@/config/JSbridge'

import Lucky from './components/lucky'
import { saveAddrInfo, fetchRecipientAddress } from './api';
// import { saveAddrInfo } from '../api';
import { getRaffleTimes, getDrawResult, fetchActivityShare, activityInfo } from '@/api/user-new';
import { connect } from 'react-redux';
import AwardModal from './components/awardModal'
import BuyModal from './components/buyModal'

import prizeVip from './images/悬浮窗/vip.png'
import prize1 from './images/悬浮窗/1.png'
import prize8 from './images/悬浮窗/8.png'
import prize15 from './images/悬浮窗/15.png'
import Delivery from "./components/delivery";
import { jumpTo, getObjectFormSerach } from "../../utils";
import OpenApp from '../../components/OpenApp';


export const isStorm = bwmodel.app === 'storm';

const active_id = 190;

const CarnivalGame = ({token}) => {
  const [loading, setLoading] = useState(false)
  const [isAnimating, setAnimating] = useState(false)

  const { source } = getObjectFormSerach(window.location.search);
  
  const luckRefs = useRef(null);
  const awardModal = useRef(null);
  const buyModal = useRef(null);
  // const raffleRef = useRef();
  // const [showModal, setShowModal] = useState(false);
  // const [showEmptyModal, setShowEmptyModal] = useState(false);
  const [showExplain, setShowExplain] = useState(false);
  const [showAwardsTips, setShowAwardsTips] = useState(false);
  
  // const [activeVisible, setActiveVisible] = useState(true)
  const [isLock, setIsLock] = useState(false)

  const [skuInfo, setSkuInfo] = useState([])

  const [raffleCount, setRaffleCount] = useState(0)  // 剩余抽奖总数

  const [totalAwardList, setTotalAward] = useState([])   // 奖励总数


  const [activeVisible, setActiveVisible] = useState(true) // 活动是否进行
  
  const [usedCount, setUsedCount] = useState(0);
  const shareRef = useRef()
  const lightRef = useRef()
  
  const [deliveryVisible, setDeliveryVisible] = useState(false);
  const deliveryRef = useRef('');
  const [showAddr,setShowAddr] = useState(false);
 
  const bodyContainer = useRef()
  // const [rankData, setRankData] = useState({
  //   buyCountsGap: 0,
  //   ranking: 0,
  //   rankingList: [],
  //   userId: ''
  // })
  const handleLuck = () => {
    //打开编辑弹窗 调用子组件身上的方法打开
    if (source === 'mini') {
      /* eslint-disable no-undef */
      wx.miniProgram.navigateTo({url: '/pages/kefu/download'})
      return
    }
    if ( process.env.REACT_APP_ENV !== 'development') {
      if (!isStorm) {
        return linkToDownload()
      }
      if (!token) {
        return handleLogin()
      }
    }
  
    const prizesMap = {
      5: 0,
      99999: 1,
      3: 2,
      93: 3,
      10: 4,
      372: 5,
      15: 6,
      31: 7
    }
    if(raffleCount === 0) {
     return Toast.info('你当前抽奖次数为0，请完成任务', 1);
    }
    if (!activeVisible) {
      return
    }
    // 埋点
    if(loading || isAnimating) {
      return 
    }

    handleUploadTrace('7th-anniversary_raffle-click', 'click')
    
    setAnimating(true) // 按钮 不可以用

    // lightRef.current.className = 'light-img'
    getDrawResult({ activityId: active_id })
      .then(res => {
     
        
        setAnimating(false)

        if (res.errors) {
          Toast.info(res.errors[0].message)
          lightRef.current.className = 'light-img light-flash'
          return
        }

        setLoading(true); // 正在转

        const { awardNum } = res.award;
  
        const parze = prizesMap[awardNum]


        setUsedCount(usedCount + 1)

        // const rotateAngle = awardAngleMap.get(awardNum)
        setRaffleCount(raffleCount - 1); 
        luckRefs.current.onStart(parze);

    }).catch(err => {
      setAnimating(false)
      setLoading(false)
    })
  }
  const onEnd = (parze) => {
    setLoading(false)  // 动画结束

    setTimeout(()=> {
      awardModal.current.show(parze, 'prize');
    },500)
  }

  const handleDraw = ()=> {
    awardModal.current.show(usedCount, 'draw');
  }
  const getDraw = (val)=> {  // 奖品打开商店
    if(isLock) { 
      // let drawNum = drawResult + 1;
      // localStorage.setItem('drawResult',drawNum)
      // setDrawResult(drawNum)
    } else {
      buyModal.current.show()  
    }
  }



  const initPage = () => {
    const params = {
      activityId: active_id, 
      
      // skuId: 3
    }
    getRaffleTimes(params)
    .then(res => {
      
      const {
        totalAwardList,
        availableCount,
        limitGoodsList,
        usedCount,
        unLocked   // 已经购买vip。可以直接领取
      } = res
  
      
      if(res.user) {
        setSkuInfo(limitGoodsList)

        setUsedCount(usedCount)
        setRaffleCount(availableCount)   // 抽奖机会总数
        setTotalAward(totalAwardList)    // 奖励总数
        setIsLock(unLocked)     //  是否已经购买年卡
      }
     
    })
    .catch(err => {

    })

    // rankingList(params)
    //   .then(res => {
    //     setRankData(res.data)
    //     // console.log(res);
    //   })


      // 是否显示地址

      fetchRecipientAddress(params)
        .then(res => {
          if(res.data) {
            setShowAddr(true)
          } else {
            setShowAddr(false)
          }
          // console.log(res);
        })
      
  }

  const linkToDownload = () => {
    // 埋点
    handleUploadTrace('7th-anniversary_link-download', 'click')
    //
    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
  }

  const handleLogin = () => {
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }

  function handleScroll(e) {
    let footer = document.getElementById('footer');
    if(footer) {
      if(window.scrollY >=20) {
        footer.classList.add('footer-freeclass-block');
      }else {
        footer.classList.remove('footer-freeclass-block');
      }
    }
   
  }
  useEffect(()=>{
    window.addEventListener('scroll', handleScroll);
    return   window.addEventListener('scroll', null);
}, [])

  useLayoutEffect(() => {
    // if (token  || process.env.REACT_APP_ENV === 'development') {
   
    // }

    initPage()


    activityInfo({id: active_id}).then(res => {
      if (res.state === 1) {
        setActiveVisible(true)
      } else {
        setActiveVisible(false)
      }
    })

    
  
  }, [token]);


  useEffect(() => {
    h5Share.main({ 
      title: `金秋10月，赢取10年会员年卡！`,
      desc: '市值风云2025年10月会员活动来袭～专属投资笔记、ETF投资地图、VIP会员....100%中奖！',
      link: process.env.REACT_APP_DEMAND_URL + 'active_190',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo9.jpg',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo9.jpg'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo9.jpg'
      }
    })

    // 埋点
    if (isStorm) {
      handleUploadTrace('7th-anniversary', 'visitor')
    } else {
      handleUploadTrace('7th-anniversary_outside', 'visitor')
    }
    //
    
  }, [])

  const activityShare = () => {
    // 埋点
    handleUploadTrace('7th-anniversary_desc-share', 'click')
    //

    if (!isStorm) {
      linkToDownload()
      return
    }
    if (shareRef.current) {
      shareRef.current.show()
    }
  }
  // const toactivityShare = (shareUrl) => {
  //   jumpTo(shareUrl)
  // }

  const handleShareClick = () => {
    if(!activeVisible) {
      return
    }
    const params = {
      "activityId": active_id,
      "shareType": 0
    }
    fetchActivityShare(params)
    .then(res => {
      const { status, availableCount } = res
      if (status === 0) {
        // 增加可用次数 availableCount
        setRaffleCount(availableCount)
      }
    })
    
    // 埋点
    handleUploadTrace('7th-anniversary_share-success', 'click')
    //
  }

  const  handleBuyClick = ( ) => {
    if(!activeVisible) {
      return
    }
    if (!isStorm) {
      linkToDownload()
      return
    }
    
    if (!token) {
      handleLogin()
      return
    }
  
    if(isLock) {  // 如果解锁 // 关闭 更新数据
      initPage()

      awardModal.current.hide();
   
    } else {
      initPage()
      buyModal.current.show()
    }    
  }
  const handleClose = ( ) => {

    initPage()
 
    if(usedCount === 1 || usedCount === 10 || usedCount === 20) { 
      setTimeout(() => {
        handleDraw()
      }, 500)
    }
  }
  
  const  handleGoShop = ( ) => {  // 点击去商店
    if(!activeVisible) {
      return
    }
    if (!isStorm) {
      return linkToDownload()
    }
    
    if (!token) {
      return  handleLogin()
      
    }

    console.log('handleGoShop', 'click');
    buyModal.current.show('click')  

  }

  const handleToRules = ( ) => {
    
    let rules_box = document.getElementById('rules_box');
    const top = rules_box.offsetTop - 100;


    window.scrollBy({
      top: top,
      left: 0,
      behavior: "smooth"
    });

  }

  
  // const handleToRank = ( ) => {
    
  //   let rules_box = document.getElementById('rank_box');
  //   const top = rules_box.offsetTop - 100;


  //   window.scrollBy({
  //     top: top,
  //     left: 0,
  //     behavior: "smooth"
  //   });

  // }

  const handleBuyClose = () => { 

    awardModal.current.hide();
    
    
    // initPage();
  }

  const handleUnlock = (goods) => {  // 去购买年卡
    // 埋点

    // if (isLockClick) {
    //   handleUploadTrace('7th-anniversary_bottom-unclock-click', 'click')
    // } else {
    //   handleUploadTrace('7th-anniversary_desc-unlock-click', 'click')
    // }
    
    
    // if (isLock && isLockClick) {
    //   return
    // }

    if (!isStorm) {
      linkToDownload()
      return
    }
    if (!token) {
      handleLogin()
      return
    }

    bridge.callHandler('nativeEvent', {
      event: 'halfScreenPay',
      params: {
        price: `${goods.skuPrice}`,
        activityTitle: goods.goodsName,
        skuId: `${goods.skuId}`,
        orderType: '1'
      },
    }, (params) => {
      try {
        const info = JSON.parse(params)
        if (info && info.params.result) {
          initPage()
       
          buyModal.current.hide()
    
        }
      } catch (error) {
        //
      }
    })
  }


  const handleSubmitAddr = (addr) => {
    
    const params = {
      activityId: 190,
      ...addr,
      // giftList: [goodsName1 ,goodsName2]
    }

    saveAddrInfo(params)
    .then(res => {
      Toast.info('地址填写成功')
      setTimeout(()=> {
        // onClose();
        setDeliveryVisible(false)
        setShowAddr(false)
      }, 1500)
   
    })
    .catch(err => {
      // onClose();
      console.log(err);
    })
  }

  // function onClose() {
    
  //   setDeliveryVisible(false);
  //   // props.onSubmit && props.onSubmit();
  // }

  function showAddrInfo(params) {
    setDeliveryVisible(true)
  }



  // const handleExplain = () => {
  //   setShowExplain(true)
  // }

  // const handleShowAwardsTips = () => {
  //   setShowAwardsTips(true)
  // }




  return <div>
     {isStorm && 
        <Header
          title="市值风云会员活动"
          right={<img onClick={activityShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
          bg_color={styles.bg_color2}
        />
      }
  
  <Container style={isStorm ? {top:'44px'} : {top: '0px'}} className={activeVisible? '': 'filter'} ref={bodyContainer}>

    <div  className='page-body' >
     
      <div className="rules_btn" onClick={()=>  jumpTo(`/active_190/rules`)}>活动<br/>规则</div>
      <div className="rules_btn rules_btn2" onClick={()=> jumpTo('https://www.wogoo.com/essay/#/?articleId=ac7231202bad499a8c3ca8e5fd08e8b5&articleType=1')}>会员<br/>介绍</div>
      {/* <div className="rules_btn rules_btn3" onClick={handleToRank}>排行<br/>榜</div> */}
     
      <div className="img_box" style={{height: '60vw'}}>
      </div>
      <div className="time">活动时间：2025.9.26-10.31</div>
      <div className="luck">
        <Lucky 
          ref={luckRefs}
          onEnd={onEnd}
        />
        <div className={`btn ${loading?'disabled':''}`} disabled={isAnimating} onClick={handleLuck}>
          <img src={require('./images/九宫格未选中态/714.png')} alt=''/>
          {/* <img src={require('./images/九宫格选中态/714.png')} alt=''/> */}
        </div>
        <div className="luck_tips">活动会员类型：风云VIP/研报畅读/短线挖掘/趋势拐点</div>
      </div>
   
      <div className="luck_num" onClick={handleToRules}>
          <div>剩余抽奖次数： {raffleCount} 次</div>
          {/* <div className="num">{raffleCount}</div> */}
          <div className="tips">获取抽奖次数 >>> </div>
        </div>


      <AwadBox className="awad_box">
        <div className="title">投资专属礼包等你拿</div>
        <div className="title_tips">开通年卡会员后，累计抽奖达以下次数可领周边</div>
        <div className="title_images">
          <img src={require('./images/awad1.png')} alt=''/>
          <img src={require('./images/awad2.png')} alt=''/>
          <img src={require('./images/awad3.png')} alt=''/>
        </div>

        <div className="gradient">
          <div className="progress"> 
            { ( usedCount <= 1) && <img src={require('./images/进度条/0.png')} alt=''/> } 
            { ( usedCount > 1 && usedCount < 10) && <img  src={require('./images/进度条/1.png')} alt=''/> } 
            { ( usedCount===10) && <img  src={require('./images/进度条/8_1.png')} alt=''/> } 
            { ( usedCount > 10 && usedCount < 20) && <img  src={require('./images/进度条/8.png')} alt=''/> } 
            { ( usedCount >= 20)  && <img  src={require('./images/进度条/15.png')} alt=''/> }
          </div>


          <div className="draw_box">
            {usedCount >= 1 ? <span >{isLock?'已领': '待领'}</span>: <span>&nbsp;&nbsp;1</span>}
            <span >{usedCount >= 10? isLock?'已领': '待领':'10 '}</span>
            <span >{usedCount >= 20? isLock?'已领': '待领':'20'}</span>
          </div>
       
          {
            !isLock && usedCount >= 1 && <div className="btn" onClick={()=>handleGoShop()}><img  src={require('./images/btn.png')} alt=''/></div>
          }

          <div className="explain" >当前已累计抽奖：{usedCount} 次</div>
          {/* 没有填写地址 */}
          {
           showAddr && <div className="addr" onClick={showAddrInfo}>购买会员且解锁周边的用户必填：<span>填写收货地址</span></div>
          }
         
        </div>
      </AwadBox>

      <div className="gradient">
       


        <div className="ruls_box" id="rules_box">
           <h3>抽奖次数获取规则</h3>
           <div className="title">在活动期间完成以下条件都可获得抽奖次数：</div>
           <div className="li">1、每日登录市值风云APP，获得1次；</div>
           <div className="li">2、首次进入抽奖页面，获得2次；</div>
           <div className="li">3、首次分享活动页面，获得1次；<span onClick={activityShare}>去分享 ></span></div>
           <div className="li">4、参加实盘比赛，每日报单，获得1次；<span onClick={
             () => jumpTo('https://f10.wogoo.com/#/stock-trading')
           }>去比赛 ></span></div>
           <div className="li">5、每天观看直播超1分钟，获得1次；</div>
         
           <div className="li">6、每购买一次会员年卡，获得6次（无上限）。<span onClick={()=>handleGoShop()}>去购买 ></span></div>
           <div className="tips">会员年卡为风云VIP年卡/研报畅读年卡/短线掘金年卡/ 趋势拐点年卡</div>
           <div>具体活动规则可点击「<span onClick={ ()=>  jumpTo(`/active_190/rules`)}>活动规则</span>」查看</div>
         
        </div>
      </div>
      
  { usedCount > 0  &&   
    <div className="bottom-container" id="footer" >
        <div className="bottom-box">
         { isLock ?
          <div className="title">
            <div>目前已得：</div>
            <div className="button" onClick={()=>handleGoShop()}>购买年卡会员</div>
          </div>
          :
           <div className="title">
           <div>购买年卡会员可得：</div>
           <div className="button" onClick={()=>handleGoShop()}>购买年卡会员</div>
         </div>
        }
        <div className="imgs_box">
         {
          totalAwardList.map(it =>  {
            return <div className="vip img_box"><div>{it.name}<br/>{372 * (it.times||1)}<span>+{it.awardNum}{ (it.times||1)>2?'':'天'}</span></div></div>
          })
         }  
          { (usedCount >= 20) && <div className="img_box img15"><div>市值风云<br/>投资笔记</div></div> }
          { (usedCount >= 10) && <div className="img_box img8"><div>市值风云<br/>ETF投资地图</div></div> } 
          { (usedCount >= 1) && <div className="img_box img1"><div>价投全景图<br/>纸质版</div></div> } 
          
        </div>
          {
            isLock ?
             <div >
               <div className="tips">
                赠送的会员天数（红色）和周边奖品会在活动结束后统一发放
              </div>
               {
                ( totalAwardList.filter(it => it.name === '风云VIP').length === 1 ) && totalAwardList.length > 1 &&
                <div className="tips2">注：风云VIP赠送的会员天数已含{
                  // 购买的其他类型会员名称，多个中间用、隔开
                    totalAwardList.filter(it => it.name !== '风云VIP').map((it,index,a) => `${it.name}${(index !== a.length -1)?'、':''}`)
                  }赠送天数，会统一根据风云VIP赠送时长进行发放
                </div>
               }
           </div>
           :
          <div className="tips" >购买会员后抽中的奖励天数会加到所购的会员时长上</div>
           
          }
        </div>
      </div>
  }
   
    </div>
    

    <ShareModal ref={shareRef} onShareClick={handleShareClick}/>

    <ModalView
        visible={showExplain}
        onClose={() => setShowExplain(false)}
        onOverlayClick={() => setShowExplain(false)}
        content={
          <ExplainCard >
            <div className="explain-card-wrap">
              <div className="explain-wrap">
                <div className="explain-card">
                  <img src={ExplainText} alt='' className="explain-img" />
                </div>
                <div className="explain-close">
                  <img onClick={() => setShowExplain(false)} className="close-btn" src={CloseBtn} alt=""/>
                </div>
              </div>
            </div>
          </ExplainCard>
        }
      />

      <ModalView
        visible={showAwardsTips}
        onClose={() => setShowAwardsTips(false)}
        onOverlayClick={() => setShowAwardsTips(false)}
        content={
          <ExplainCard >
            <div className="explain-card-wrap">
              <div className="explain-wrap explain-wrap1">
                <div className="explain-card1">
                  <div className="title1">
                  榜单奖励说明
                 
                  </div>
                  <p>1.榜单根据本次活动所有用户在活动期间购买会员年卡的总次数进行排行，仅前10名有机会获得榜单奖励；</p>
                   <p> 2.榜单排名：购买次数优先，若购买次数一样，则购买会员年卡时间的越早，排名越靠前；</p>
                   <p> 3.榜单奖励为：每天排在榜单前10的用户,当日抽奖次数+1；</p>
                   <p> 4.榜单每日18:00更新一次</p>
                  {/* <img src={ExplainText} alt='' className="explain-img" /> */}
                </div>
                {/* <div className="explain-close">
                  <img onClick={() => setShowExplain(false)} className="close-btn" src={CloseBtn} alt=""/>
                </div> */}
              </div>
            </div>
          </ExplainCard>
        }
      />

      {/* 奖品弹框 */}
      <AwardModal 
        ref={awardModal} 
        isLock={isLock} 
        getDraw={getDraw}
        unlock={handleBuyClick}
        onClose={() => handleClose()}
      />      
    <BuyModal  
      ref={buyModal}
      skuInfo={skuInfo}
      onBuy={ handleUnlock }
      onClose={()=> handleBuyClose()}
    ></BuyModal>
      {
        !isStorm && 
        <div>
          <OpenApp bottom='bottom'></OpenApp>
        </div>
       }
    <Delivery visible={deliveryVisible} ref={deliveryRef} onClose={() => setDeliveryVisible(false)} onSubmit={handleSubmitAddr} activityId={190} />
  </Container>
  </div>
  ;
}

const mapStateToProps = (state) => ({
  token: state.user.accessToken
});

export default React.memo(connect(mapStateToProps)(CarnivalGame))


const Container = styled.div`

@keyframes liuguang {
  00% {
    left: -105px;
  }

  20% {
    left: -15px;
  }
 
 
  100% {
    left: 50vw;
  }
}
  .time  {
    position: absolute;
    left: 0;
    top: 56vw;
    width:100%;
    text-align: center;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 48px;
    background: linear-gradient(0deg, rgba(255,224,130,0.6) 0%, rgba(255,255,255,0.6) 48.7548828125%);
    -webkit-background-clip: text;

  }
  .luck_tips {
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 21px;
    text-align: center;
    position: absolute;
    left: 0;
    bottom: 7vw;
    width: 100%;
  }
  position: relative;
  top: 44px;
  // padding-top: 44px;
  max-width: 100%;
  width: 100%;
  overflow: hidden;
  background-image: url(${bgImage});
  background-repeat: no-repeat;
  background-size: contain;
  background-color: #F0374A;
  &.filter {
    filter: grayscale(95%);
  }
  .page-body {
    position: relative;
  }
  .rules_btn {
    position: absolute;
    right: 0;
    top: 10px;
    box-shadow: 0px 0px 8px 0px rgba(197,51,36,0.18);
    color: #FFFFFF;
    font-size: 12px;
    text-align: center;
    line-height: 18px;
    width: 38px;
    height: 50px;
    background: rgba(150,12,110,0.5);
    border-radius: 8px 0px 0px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .rules_btn2 {
    top:70px;
    z-index: 3;
  }
  .rules_btn3 {
    position: fixed;
    top: 340px;
    z-index: 100;
  }
  .img_box {
    min-width: 80px;
    img{
      font-size:0px;
      vertical-align: middle;
      width: 100%;
    }
  }
  .img_box2 {
    width: 97.33vw;
    margin: auto;
    // marign-top: -4px;
  }
  .luck {
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    position: relative;
    justify-content: center;
    width: 100%;
    height: 104vw; // 743
    >div {
      margin-top: 11vw;
    }
    .btn {
      margin-top:0;
      position: absolute;
      z-index: 1;
      bottom: 0px;
      display: block;
      width: 48.9vw;
      height: 14vw;
      overflow: hidden;
      // border-radius: px;
      top: 37vw;
      z-index: 20;
      font-size:20px;
      // background: #FC6253;
      width 24vw;
      height: 24vw; 
      >img {
        width: 100%;
        height: 100%;
        position: relative;
       
      }
      img:active {
        transform: translateY(3px);
      }
      
      &.disabled {
        img:active {
          transform: translateY(0px);
        }
      }
    }
    
  }
    .luck_num {
      justify-content: space-around;
      text-align: center;
      position: absolute;
      top: 161vw;
      z-index: 20;
      font-size: 13px;
      color: #ffffff;
      line-height: 20px;
      width: 100%;
      .tips {
        color: #FCFF98;
      }
    }
  .gradient {
    margin: auto;
    box-sizing: border-box;
    .btn {
      margin: auto;
      margin-top: 15px;
      width: 84.8vw;
      >img {
        width: 100%;
      }
    }
    
  }
  .progress {
    text-align: center;
    padding-top: 2.5vw;
    img {
      width: 66.8vw;
    }
    // display: flex;
  }
  .draw_box {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    padding: 0 8.2vw;
    font-size: 12px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #FFFDE6;
  }
  .explain {
    margin-top: 4vw;
    margin-bottom: 6vw;
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFEDCA;
    line-height: 15px;
  }
  .addr {
    background-color: rgba(0,0,0,.45);
    // width: 300px;
    line-height: 34px;
    border-radius: 17px;
    span {
      color:#FFE762;
    }
  }
  .split_box {
    img {
      max-width: 100%
    }
  }
  .ruls_box {
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 240px;
    font-size: 15px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 30px;
    h3 {
      text-align:center;
    }
    .li{
      word-wrap: keep-all;
      padding-left: 2em;
      text-indent: -2em;
    }
   
    span {
      color: #FFF32B;
    }
    .tips {
      font-size: 13px;
    }
    .tips2 {
      marging-top:13px;
      font-size: 12px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 13px;
    }
  }
  
  .bg-container {
    width: 100%;
    position: relative;
    z-index: 0;
    .bg-img {
      width: 100%;
    }
  }
  .explain-btn {
    position: fixed;
    top: 273px;
    right: 0;
    width: 47px;
    height: 50.5px;
    z-index: 10;
  }
  .bottom-container {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: -100%;
    transition: bottom 0.5s;
    &.footer-freeclass-block {
        bottom: 0;
    }
    z-index: 100;
    .bottom-box {
      padding: 15px;
      box-sizing: border-box;
      background: linear-gradient(145deg, #FE878A,#FF554D);
      border-radius: 10px 10px 0 0;
      width: 100%;
      position: relative;
      .title {
        pading: 5px;
        box-sizing: border-box;
        margin-bottom: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        .button {
          width: 98px;
          height: 28px;
          border: 1px solid #EAE0B2;

          background: linear-gradient(270deg, #EC5519 0%, #EC5519 100%);
          box-shadow: 0px 1px 3px 0px rgba(168,89,37,0.18);
          border-radius: 14px;
          text-align: center;
          line-height:28px;
          font-size: 12px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #FFFFFF;
        }
      }
      .imgs_box {
        display: flex;
        width: 100%;
        overflow: scroll;
        .img_box {
          width: 80px;
          height: 83px;
          background-repeat: no-repeat;
          background-size: cover;
          font-size: 12px;
          font-family: SourceHanSansSC;
          font-weight: 500;
          color: #A92D2D;
          text-align: center;
          padding-top: 54px;
          box-sizing: border-box;
         
          >div {
            // color: #FFFFFF;
             transform-origin: center;
          transform: scale(0.78);
               >span {
                color:#EB582D;
              }
          }
       
        }
        .vip {
          background-image: url(${prizeVip});
        }
        .img1 {
          background-image: url(${prize1});
        }
        .img8 {
          background-image: url(${prize8});
        }
        .img15 {
          background-image: url(${prize15});
        }
       
      }
      .tips {
        margin-top: 8px;
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 26px;
      }


      .bottom-img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .unlock-btn {
        width: 88px;
        height: 74px;
        position: absolute;
        bottom: 18px;
        right: 22px;
        z-index: 10;
      }
      .reward-img {
        width: 197px;
        height: 75.5px;
        position: absolute;
        right: 15px;
        top: -57.5px;
      }
      
      .total-award {
        font-size: 38px;
        font-weight: bold;
        color: #FDE200;
        line-height: 38px;
      }
      .total-award-unit {
        font-size: 20px;
        font-weight: 800;
        color: #FDE200;
        line-height: 20px;
      }
    }
  }

  .raffle-container {
    position: relative;
    z-index: 1;
  }

  .wheel-container {
    width: 100%;
    position: absolute;
    top: 180px;
    left: 0;
    display: flex;
    justify-content: center;
    .wheel-img-bg {
      margin: 0 10px;
      position: relative;
      font-size: 0;
      max-width: 355px;
      .wheel-bg {
        width: 100%;
        position: relative;
        z-index: 1;
      }
      .pointer-container {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 3;
        justify-content: center;
        display: flex;
        align-items: center;
        .pointer-box {
          font-size: 0;
          width: 111px;
          height: 111px;
          position: relative;
          .pointer-img {
            width: 111px;
            position: absolute;
            bottom: 0;
            left: 0;
          }
          .raffle-area {
            width: 111px;
            height: 111px;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 3;
          }
        }
      }
    }
    .light-container {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      .light-img {
        width: 100%;
        height: 100%;
      }
    }
    .stand-container {
      position: absolute;
      height: 46px;
      width: 100%;
      bottom: -36.5px;
      left: 0;
      .stand-box {
        position: relative;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0;
        .stand-img {
          width: 259.5px;
          height: 46px;
        }
        .stand-text {
          font-size: 15px;
          line-height: 15px;
          text-align: center;
          position: absolute;
          width: 100%;
          left: 0;
          bottom: 10.5px;
          color: #FFFEEE;
        }
      }
    }
  }


  .describe-container {
    position: absolute;
    left: 0;
    top: 595px;
    width: 100%;
    .desc-title-wrap {
      display: flex;
      justify-content: center;
      .desc-title {
        width: 241.5px;
        height: 22.55px;
      }
    }
    .desc-text-wrap {
      width: 100%;
      padding-left: 23.5px;
      padding-right: 17.5px;
      margin-top: 18.5px;
      font-size: 15px;
      color: #FDFDFD;
      font-weight: 400;
      line-height: 23px;
      box-sizing: border-box;
      .share-row {
        display: flex;
        align-items: center;
      }
      .share-btn {
        display: inline-block;
        .share-text {
          color: #FFF228;
          font-size: 18px;
          font-weight: bold;
        }
        .share-tag {
          width: 26.5px;
          height: 13.5px;
          margin-left: 4px;
          position: relative;
          top: 1px;
        }
      }
    }
  }

  @keyframes light-flash {
    0% { opacity: 1; }
    25% { opacity: 0; }
    50% { opacity: 1; }
    75% { opacity: 0; }
    100% { opacity: 1; }
  }
  .light-flash {
    animation-name: light-flash;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
  .rank_box {
    padding: 3.2vw;
    box-sizing: border-box;
    margin: 3.2vw auto;
    width: 92vw;
    background: #FF6F6F;
    border-radius: 15px;
    color: #FFFFFF;
    .content_empty {
      height: 30vw;
      text-align: center;
      line-height: 30vw;
      font-size: 20px;
    }
    .title {
      font-weight: bold;
      font-size: 24px;
      color: #FFFFFF;
      line-height: 40px;
      text-align: center;
    }
    .myRank {
      margin: 8px 0;
      font-size: 15px;
      .num {
        color:#FFE379;
      }
    }
  }
  .rank {
    width: 40px;
  }
  .name {
    width: 90px;
  }
  .number {
    width: 80px;
  }
  .awards_tips {
    width: 100px;
    img {
      margin-left: 4px;
      vertical-align: middle;
    }
  }
  .table—td {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    margin-top: 12px;
    >div {
      text-align: center;
    }
  }
  .table—tr {
    display: flex;
    justify-content: space-between;
    text-align: center;
    font-size: 13px;
    line-height: 28px;
   .name {
      width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    
  }
`;

const ExplainCard = styled.div`
  img {
  src: url
  }
  &.award   .explain-card-wrap  {
    .explain-wrap {
      background-image: url(${bgModal});
      background-repeat: no-repeat;
      background-size: contain;
      // height: calc(80vh - 100px);
      // height:  calc(392px + 100px);
      width: 272px;
      // width: 372px;
      height: 420px;
    }
    
  }
  .explain-card-wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    max-width: 334px;
    position: relative;
    padding-bottom: 60px;
   
    .explain-card1  {
      margin: auto;
      width: 318px;
      height: 318px;
      background-image: url(${bgModal2});
      background-repeat: no-repeat;
      background-size: contain;
      padding: 33px 20px;
      box-sizing: border-box;
      .title1 {
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        font-size: 40px;
        color: #000000;
        line-height: 45px;
      }
      p {
        font-size: 15px;
        font-weight: 800;
          color: #000000;
      }
    }
    .explain-wrap {
      height: calc(100vh - 100px);
      &.explain-wrap1 {
       height:auto;
     }
      .explain-card {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        .num {
          width: 382px;
          img {
            width: 100%;
          }
        }
        .award_text {
          margin-top: 210px;
          text-align: center;
          .title {
            color: #000000;
            font-size: 20px;
            line-height: 20px;
          }
          .name {
            margin-top: 15px;
            font-size: 38px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #FF7825;
          }
          .description {
            margin-top: 10px;
            font-size: 12px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #0E0509;
          }
          .btn {
            width: 171px;
            margin:auto;
            margin-top: 17px;
            >img {
              width: 100%;
            }
          }
        }
      
        &::-webkit-scrollbar {
          display: none;
        }
        &::-webkit-scrollbar {
          display: none;
        }
        .explain-img {
          width: 100%;
        }
        .explain-text {
          color: #fff;
          font-size: 30px;
          >img {
           width: 100%;
          }
        }
      }
      .explain-close {
        height: 60px;
        display: flex;
        width: 100%;
        justify-content: center;
        box-sizing: border-box;
        padding-top: 2px;
        .close-btn {
          width: 20px;
          height: 20px;
        }
      }
    }
  }


  .empty-wrap {
    position: relative;
    padding: 0 35px;
    width: 100%;
    max-width: 305px;
    .empty-card {
      width: 100%;
      height: 115.75px;
    }
    .empty-close-btn {
      right: 46px;
      top: 12px;
      width: 20px;
      height: 20px;
      position: absolute;
      z-index: 5;
    }
  }
 
`;


const AwadBox = styled.div`
width: 92vw;
margin: auto;
margin-top: 10vw;
background: #FF6F6F;
// background: red;
border-radius: 15px;
 color: #FFFFFF;
  text-align: center;
  box-sizing: border-box;
  padding: 4.5vw;
  .title {
    font-size: 24px;
   
    line-height: 40px;
  }
  .title_tips {
  
  }
  .title_images {
    margin-top: 3vw;
    display: flex;
    justify-content: space-between;
    img {
      width: 18.4vw;
    }
  }
`


// WEBPACK FOOTER //
// ./src/views/activity_190/index.js